<script lang="ts" setup>
defineSlots<{
  default?: () => unknown;
}>();
</script>

<template>
  <div :class="$style.root" data-ui-component="UiTableContextPanel">
    <slot />
  </div>
</template>

<style lang="scss" module>
.root {
  display: inline-flex;
  align-items: center;
  background: var(--ui2-background-primary, #fff);
  border: 1px solid var(--ui2-stroke-secondary, #e4e5e8);
  border-radius: 10px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.04);
  overflow: hidden;

  :global(
    [data-ui-component='UiTableContextPanelItem'] + [data-ui-component='UiTableContextPanelItem']
  ) {
    border-left: 1px solid var(--ui2-stroke-tertiary, #f0f1f4);
  }
}
</style>
